import React from "react";
import { Link } from "react-router-dom";
import Header from "@/components/landing/Header";
import PageFooter from "@/components/landing/PageFooter";
import { EXPERIENCE_PROGRAMS } from "@/data/experiencePrograms";

function ProgramCard({ program }) {
  return (
    <article
      data-testid={`program-card-${program.slug}`}
      className="group bg-warm border border-hairline hover:border-[var(--accent-gold)] transition-colors duration-500 flex flex-col h-full"
      style={{ boxShadow: "0 10px 40px -28px rgba(160, 122, 40, 0.22)" }}
    >
      <Link to={program.to} className="block overflow-hidden" tabIndex={-1} aria-hidden="true">
        <img
          src={program.image}
          alt={program.imageAlt}
          className="w-full aspect-[16/10] object-cover transition-transform duration-[1200ms] group-hover:scale-[1.03]"
          style={{ filter: "saturate(0.98) contrast(1.02)" }}
          loading="lazy"
        />
      </Link>
      <div className="px-7 md:px-10 py-9 md:py-11 flex flex-col flex-grow text-center">
        <p
          data-testid={`program-card-${program.slug}-meta`}
          className="font-body text-[10.5px] md:text-[11px] tracking-[0.32em] uppercase text-gold mb-5"
        >
          {program.date} · {program.location}
        </p>
        <h2 className="font-serif-display text-[28px] sm:text-[32px] md:text-[36px] leading-[1.2] text-graphite mb-6">
          {program.title}{" "}
          <em className="text-gold" style={{ fontStyle: "italic" }}>
            {program.titleAccent}
          </em>
        </h2>
        <p className="font-serif-display italic text-graphite text-[18px] md:text-[20px] leading-[1.6] max-w-lg mx-auto mb-10">
          {program.lead}
        </p>
        <div className="flex-grow" aria-hidden="true" />
        <div className="pt-6 border-t border-hairline">
          <Link
            to={program.to}
            data-testid={`program-card-${program.slug}-cta`}
            className="cta-gold-outline inline-flex items-center gap-3 px-8 py-3.5 text-[11.5px] md:text-[12px] uppercase font-body font-medium tracking-[0.22em]"
          >
            Részletek
            <span aria-hidden="true">→</span>
          </Link>
        </div>
      </div>
    </article>
  );
}

export default function ExperiencePrograms() {
  const single = EXPERIENCE_PROGRAMS.length === 1;
  return (
    <main data-testid="experience-programs-page" className="bg-warm text-graphite min-h-screen">
      <Header />
      <div className="pt-20 md:pt-24" />

      <section data-testid="experience-programs-hero" className="px-6 md:px-10 pt-6 md:pt-10 pb-8 md:pb-12">
        <div className="max-w-2xl mx-auto text-center">
          <p className="font-body text-[11px] md:text-[12px] tracking-[0.42em] uppercase text-gold mb-5">
            — Élményprogramok
          </p>
          <h1
            data-testid="experience-programs-title"
            className="font-serif-display text-[36px] sm:text-[44px] md:text-[52px] leading-[1.12] text-graphite tracking-tight"
          >
            Élmény
            <em className="text-gold" style={{ fontStyle: "italic" }}>
              programok
            </em>
          </h1>
        </div>
      </section>

      <section data-testid="experience-programs-grid" className="px-5 md:px-10 pb-14 md:pb-20">
        <div
          className={`mx-auto grid grid-cols-1 gap-6 md:gap-8 ${
            single ? "max-w-3xl" : "max-w-6xl md:grid-cols-2"
          }`}
        >
          {EXPERIENCE_PROGRAMS.map((p) => (
            <ProgramCard key={p.slug} program={p} />
          ))}
        </div>
      </section>

      <PageFooter />
    </main>
  );
}
